import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectionStrategy
} from '@angular/core'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { ISelectItem } from '@lla-platform/core/core-ui'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { DropdownBottomSheetComponent } from '../dropdown-bottom-sheet/dropdown-bottom-sheet.component'

@UntilDestroy()
@Component({
  selector: 'lla-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DropdownMenuComponent implements OnChanges, AfterViewInit {
  @Input() selectedItem?: any
  @Input() placeHolder: string
  @Input() disable = false
  @Input() fullWidth = false
  @Input() items: ISelectItem[] = []
  @Input() extraClass = ''
  @Input() bottomSheet = false
  @Input() bottomSheetTitle = 'Sort by'

  @Output() selectedItemChanged = new EventEmitter<any>()

  @ViewChild('parentContainer', { static: true }) parentContainer!: ElementRef<HTMLDivElement>

  selectedItemLabel?: string
  menuWidth: number | 'auto' = 'auto'

  constructor(private bottomSheetService: MatBottomSheet) {}

  ngOnChanges(changes: SimpleChanges): void {
    const itemValue = changes['selectedItem']?.currentValue
    if (itemValue) {
      this.selectedItemLabel = this.items?.find((el) => el.value === itemValue)?.label
    }
  }

  ngAfterViewInit(): void {
    this.calculateMenuWidth()
  }

  onMenuOpened(): void {
    this.calculateMenuWidth()
  }

  private calculateMenuWidth(): void {
    if (this.fullWidth && this.parentContainer?.nativeElement) {
      // Use setTimeout to ensure the calculation happens after the current change detection cycle
      setTimeout(() => {
        this.menuWidth = this.parentContainer.nativeElement.clientWidth
      })
    } else {
      this.menuWidth = 'auto'
    }
  }

  openBottomSheet() {
    this.bottomSheetService
      .open(DropdownBottomSheetComponent, {
        data: {
          items: this.items,
          selectedItem: this.selectedItem,
          title: this.bottomSheetTitle
        }
      })
      .afterDismissed()
      .pipe(untilDestroyed(this))
      .subscribe((value) => {
        if (value !== undefined) {
          this.selectedItemChanged.emit(value)
        }
      })
  }
}
